import BrokenImageOutlinedIcon from "@mui/icons-material/BrokenImageOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { Box, Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";

import { resolveUploadUrl } from "../../../../infrastructure/utils/resolveUploadUrl";
import {
  isImageFile,
  isPdfFile,
} from "../../shared/files/filePreviewUtils";
import FullscreenImageOverlay from "./FullscreenImageOverlay";

const MehrsanLogAttachment = ({ url, fileBaseUrl = "", compact = false }) => {
  const [broken, setBroken] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);

  const rawUrl = useMemo(() => {
    if (!url || typeof url !== "string") return null;
    const trimmed = url.trim();
    return trimmed && trimmed !== "/" ? trimmed : null;
  }, [url]);

  if (!rawUrl) return null;

  const resolvedUrl = resolveUploadUrl(rawUrl, fileBaseUrl);
  const isImage = isImageFile(rawUrl) && !broken;
  const isPdf = isPdfFile(rawUrl);

  if (isImage) {
    return (
      <Box sx={{ mt: 0.5 }}>
        <Box
          component="img"
          src={resolvedUrl}
          alt="پیوست"
          onError={() => setBroken(true)}
          onClick={() => setFullscreen(true)}
          sx={{
            maxWidth: compact ? 120 : 160,
            maxHeight: compact ? 80 : 120,
            borderRadius: 1,
            border: 1,
            borderColor: "divider",
            cursor: "pointer",
            objectFit: "cover",
            display: broken ? "none" : "block",
          }}
        />
        {broken ? (
          <Stack direction="row" spacing={0.5} alignItems="center" color="text.secondary">
            <BrokenImageOutlinedIcon fontSize="small" />
            <Typography variant="caption">نمایش تصویر ممکن نیست</Typography>
            <Button
              size="small"
              variant="text"
              href={resolvedUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              باز کردن لینک
            </Button>
          </Stack>
        ) : null}
        <FullscreenImageOverlay
          open={fullscreen}
          onClose={() => setFullscreen(false)}
          src={resolvedUrl}
          title="پیوست"
        />
      </Box>
    );
  }

  if (!resolvedUrl) {
    return (
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
        پیوست نامعتبر
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5, flexWrap: "wrap" }}>
      {isPdf ? (
        <PictureAsPdfOutlinedIcon fontSize="small" color="action" />
      ) : (
        <DescriptionOutlinedIcon fontSize="small" color="action" />
      )}
      <Button
        size="small"
        variant="text"
        href={resolvedUrl}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<OpenInNewIcon fontSize="inherit" />}
        sx={{ minWidth: 0, px: 0.5 }}
      >
        <Typography variant="caption">مشاهده / دانلود</Typography>
      </Button>
    </Stack>
  );
};

MehrsanLogAttachment.propTypes = {
  url: PropTypes.string,
  fileBaseUrl: PropTypes.string,
  compact: PropTypes.bool,
};

export default MehrsanLogAttachment;
